module.exports = __webpack_public_path__ + "img/logo-gray.d56f1f82.png";